import { render, staticRenderFns } from "./o-modal.vue?vue&type=template&id=35d5876c&"
import script from "./o-modal.js?vue&type=script&lang=js&"
export * from "./o-modal.js?vue&type=script&lang=js&"
import style0 from "./o-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports